<template>
  <main id="home" class="page-container" v-if="$route.path === '/home'">
    <!-- <div id="square">
      <router-link to="/home/clienti" class="router-link-reset">
        <div id="customers" class="square">
          <img
            src="@/assets/account_circle.png"
            alt="customer"
            class="home_icons"
          />
          <p>Clienti</p>
        </div>
      </router-link>
      <router-link to="/home/preventivi" class="router-link-reset">
        <div id="quotes" class="square">
          <span class="euro_icon home_icons">€</span>
          <p>Preventivi</p>
        </div>
      </router-link>
      <router-link to="/home/stock" class="router-link-reset">
        <div id="items" class="square">
          <img src="@/assets/icon_carrier.png" alt="stock" class="home_icons" />
          <p>Magazzino</p>
        </div>
      </router-link>
    </div> -->
    <div class="cards-center-wrapper">
      <div class="cards-column">
        <div class="welcome-header">
          <p class="welcome-text">
            <span class="welcome-greeting">Bentornato/a,</span>
            <span class="welcome-name"> {{ operatorName }}</span
            ><span class="welcome-greeting">. 👋</span>
          </p>
        </div>
        <section id="square" class="cards-grid">
          <router-link
            v-if="isAdmin"
            to="/home/clienti"
            class="card"
            aria-label="Clienti"
          >
            <span class="icon-wrap">
              <img src="@/assets/account_circle.png" alt="" />
            </span>
            <span class="label">Clienti</span>
          </router-link>

          <router-link
            v-if="isAdmin"
            to="/home/preventivi"
            class="card"
            aria-label="Preventivi"
          >
            <span class="icon-wrap">
              <span class="euro_icon">€</span>
            </span>
            <span class="label">Preventivi</span>
          </router-link>

          <router-link
            v-if="isAdmin"
            to="/home/ordini"
            class="card"
            aria-label="Ordini"
          >
            <span class="icon-wrap">
              <i class="fa-solid fa-clipboard-list" aria-hidden="true"></i>
            </span>
            <span class="label">Ordini</span>
          </router-link>

          <router-link to="/home/magazzino" class="card" aria-label="Magazzino">
            <span class="icon-wrap">
              <i class="fa-solid fa-warehouse" aria-hidden="true"></i>
            </span>
            <span class="label">Magazzino</span>
          </router-link>

          <router-link to="/home/listini" class="card" aria-label="Listini">
            <span class="icon-wrap">
              <img src="@/assets/icon_carrier.png" alt="" />
            </span>
            <span class="label">Listini</span>
          </router-link>
        </section>
      </div>
    </div>
  </main>
  <router-view></router-view>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {};
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.isAdmin ?? false;
    },
    operatorName() {
      return this.$store.state.currentUser?.operatorName ?? "";
    },
  },
  mounted() {
    // console.log("this.$route.query", this.$route.query);
    const { firstLogin } = this.$route.query || {};
    if (firstLogin === "1") {
      this.$toast.success(
        "Benvenuto! Abbiamo inviato una password iniziale al tuo indirizzo email"
      );
      // pulisco la query per evitare doppi toast
      const q = { ...this.$route.query };
      delete q.firstLogin;
      this.$router.replace({ path: this.$route.path, query: q });
    }
    const urlParams = new URLSearchParams(window.location.search);
    // console.log("urlParams:", urlParams);
    // if (urlParams.get("calendar") === "connected") {
    //   alert("Google Calendar collegato con successo!");
    // }

    // Logica per google calendar, al momento non utilizzata
    if (urlParams.get("calendar") === "connected") {
      // Mostra un messaggio di successo, ad es.:
      // this.$toast.open("Google Calendar collegato con successo!");
      this.$toast.open({
        message: "Accesso su Google Calendar effettuato con successo",
        type: "success",
      });
    }
    this.$toast.clear();
  },
  methods: {},
};
</script>

<style src="@/css/HomePage.css"></style>
